import { isInteger } from 'lodash'

export default (
  page: number | string = 1,
  limit: number,
  queries: Record<string, any> = {}
): Record<string, any> => {
  let parsedPage = parseInt(String(page), 10)

  if (!isInteger(parsedPage) || parsedPage < 1) {
    parsedPage = 1
  }

  return {
    ...queries,
    limit,
    offset: (parsedPage - 1) * limit
  }
}
